import { render, staticRenderFns } from "./WebsiteCreateScreen.vue?vue&type=template&id=630dc486&scoped=true&lang=pug"
import script from "./WebsiteCreateScreen.vue?vue&type=script&lang=ts"
export * from "./WebsiteCreateScreen.vue?vue&type=script&lang=ts"
import style0 from "./WebsiteCreateScreen.vue?vue&type=style&index=0&id=630dc486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630dc486",
  null
  
)

export default component.exports